import Vue from 'vue';
import ItemLimiter from '@app/components/Utilities/ItemLimiter.vue';
import VideoComponent from '@app/components/Video.vue';
export default Vue.extend({
    components: {
        ItemLimiter: ItemLimiter,
        VideoComponent: VideoComponent
    },
    props: {
        block: Object
    },
    computed: {
        projects: function () {
            return this.block.localized.projects;
        }
    },
    methods: {
        getProjectLogo: function (project) {
            return this.$helpers.taggedFirst(project.images, 'logo');
        }
    }
});
